"use client";

import type { ReactNode } from "react";
import { track } from "@vercel/analytics";

import { reactWebAppHref } from "@/lib/reactWebAuthUrl";
import { useLocale } from "next-intl";
import { Link } from "@/i18n/navigation";

type AnalyticsValue = string | number | boolean;

export default function PublicSiteTrackedLink({
  analytics,
  additionalEventName,
  children,
  className,
  eventName,
  href,
}: Readonly<{
  analytics: Readonly<Record<string, AnalyticsValue>>;
  additionalEventName?: string;
  children: ReactNode;
  className?: string;
  eventName: string;
  href: string;
}>) {
  const locale = useLocale();
  const destination = href === "/app-directory" ? reactWebAppHref(locale,"directory") : href === "/app-skyrules" ? reactWebAppHref(locale,"skyrules") : href;
  return (
    <Link
      className={className}
      href={destination}
      onClick={() => {
        track(eventName, analytics);
        if (additionalEventName) {
          track(additionalEventName, analytics);
        }
      }}
    >
      {children}
    </Link>
  );
}
